<template>
  <div class="box" style="display: flex;flex-wrap: wrap">
    <div>
      <span>电导率</span>
      <span>{{monitor.a209}}m/s</span>
    </div>
    <div>
      <span>水质PH</span>
      <span>{{monitor.a211}}PH</span>
    </div>
    <div>
      <span>流量</span>
      <span>{{monitor.a230}}m³/h</span>
    </div>
  </div>
</template>
<script>
  import { monitorData } from '@/api/demo.js'
  export default {
    name: 'LaborPlan',
    props: {
      sn:{
        type:String,
        required:false
      }
    },
    data() {
      return {
        monitor:{}
      }
    },
    mounted() {
      this.monitorDataGet()
      let time=null
      time=setInterval(()=>{
        this.monitorDataGet()
      },60000)
      console.log(this.phase)
    },
    methods: {
      monitorDataGet() {
        monitorData(this.sn).then(data=>{
          this.monitor=data
          console.log(data)
        })
      }
    }
  }
</script>
<style scoped>
  .box > div{
    margin-right:10px ;
  }
</style>



// WEBPACK FOOTER //
// src/components/monitor/MonitorDemo/Irrige.vue